import GetFupUsersRequestModelBase from '../_generated/modelBases/get-fup-users-request-model-base';

export default class GetFupUsersRequestModel extends GetFupUsersRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
